module.exports = __webpack_public_path__ + "img/04f-Shop_651.0c948c10.jpg";